var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVideoSvg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.798,
    height: 17.848,
    viewBox: "0 0 23.798 17.848",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-video-camera",
    "data-name": "Icon metro-video-camera",
    d: "M11.495,9.5a3.718,3.718,0,1,1,3.718,3.718A3.718,3.718,0,0,1,11.495,9.5Zm-8.924,0a3.718,3.718,0,1,1,3.718,3.718A3.718,3.718,0,0,1,2.571,9.5Zm17.848,7.437V14.708a1.492,1.492,0,0,0-1.487-1.487H4.058a1.492,1.492,0,0,0-1.487,1.487v7.437a1.492,1.492,0,0,0,1.487,1.487H18.932a1.492,1.492,0,0,0,1.487-1.487V19.914l5.949,3.718V13.221l-5.949,3.718Zm-2.975,3.718H5.545V16.2h11.9Z",
    transform: "translate(-2.571 -5.784)",
    fill: "#757575"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoSvg);
export default __webpack_public_path__ + "static/media/video-svg.ab91b1c5da2335fc14041daafadbb46c.svg";
export { ForwardRef as ReactComponent };